import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { IProcesso } from '../../interfaces/processo.interface';

// Registrar os elementos necessários para o gráfico de pizza
ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({processo}: {processo: IProcesso | undefined}) => {
    // Definindo os dados do gráfico
    const data = {
        labels: [
            'Materia-prima', 
            'Energia', 
            'Maquinas', 
            'Colaborador',
            'Insumos', 
            /* 'Purple' */
        ], // Rótulos para cada fatia do gráfico
        datasets: [
            {
                label: 'Votos',           // Título do conjunto de dados
                data: [
                    processo?.despesaMadeira, 
                    processo?.despesaEnergia, 
                    processo?.despesaMaquina, 
                    processo?.despesaColaborador,
                    processo?.despesaInsumos, 
                    /* 2 */
                ],  // Quantidade de votos para cada fatia
                backgroundColor: [        // Cores de fundo para cada fatia
                    'rgba(255, 99, 132, 0.6)',
                    'rgba(54, 162, 235, 0.6)',
                    'rgba(255, 206, 86, 0.6)',
                    'rgba(75, 192, 192, 0.6)',
                    'rgba(153, 102, 255, 0.6)',
                ],
                borderColor: [            // Cores das bordas das fatias
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                ],
                borderWidth: 1,           // Largura das bordas
            },
        ],
    };

    // Opções do gráfico
    const options = {
        responsive: true,    // Torna o gráfico responsivo
        plugins: {
            legend: {
                position: 'top' as const, // Posição da legenda
            },
            title: {
                display: true,            // Exibe o título
                text: 'Distribuição de Votos', // Texto do título
            },
        },
    };

    return <Pie data={data} options={options} />;
};

export default PieChart;
